(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/spelpaus-react/assets/react/pages/first-page/components/svs-suspension-navigate.js') >= 0) return;  svs.modules.push('/modules/spelpaus-react/assets/react/pages/first-page/components/svs-suspension-navigate.js');
'use strict';

const {
  ReactButton: Button
} = svs.ui;
const {
  useHistory
} = ReactRouterDOM;
const {
  ROUTE
} = svs.spelpaus.constants;
const SvsSuspensionNavigate = () => {
  const history = useHistory();
  const handleOnClick = e => {
    e.preventDefault();
    history.push(ROUTE.svsSuspension);
  };
  return React.createElement(React.Fragment, null, React.createElement("h2", {
    className: "h1 align-left"
  }, "Spelpaus Svenska Spel"), React.createElement("div", {
    className: "align-left"
  }, "H\xE4r kan du ta en spelpaus. V\xE4lj vilka spel du vill pausa dig fr\xE5n och hur l\xE4nge. Du kan v\xE4lja att pausa dig fr\xE5n alla spel, endast lotter och KenoXpress eller endast Vegas. Observera att varken du sj\xE4lv eller Svenska Spel kan h\xE4va en spelpaus i f\xF6rtid."), React.createElement(Button, {
    block: true,
    className: "margin-top-2",
    inverted: true,
    onClick: handleOnClick,
    size: 300
  }, "Spelpaus p\xE5 svenska spel"));
};
svs.spelpaus.pages.firstPage.components.SvsSuspensionNavigate = SvsSuspensionNavigate;

 })(window);